import React, { FC } from 'react';
import { DevicesAPI } from 'api/DevicesAPI';
import { CheckCircleTwoTone } from '@ant-design/icons/lib';
import { Button } from 'antd';
import { useMutation } from 'react-query';
import { ButtonProps } from 'antd/lib/button';
import { green } from '@ant-design/colors';
import { DeviceModeType } from 'models/higoDevice';

export interface AssignDeviceToPartnerButtonProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href' | 'size'> {
  businessPartnerId: number;
  deviceId: number;
  deviceModeType: DeviceModeType;
}

export const AssignDeviceToPartnerButton: FC<AssignDeviceToPartnerButtonProps> = ({
  businessPartnerId,
  deviceId,
  deviceModeType,
  ...buttonProps
}) => {
  const [mutate, { isLoading, isSuccess }] = useMutation(
    DevicesAPI.assignToPartner
  );
  const handleClick = () => {
    mutate({
      businessPartnerId,
      deviceId,
      deviceModeType,
    });
  };

  return isSuccess ? (
    <CheckCircleTwoTone
      twoToneColor={green.primary}
      style={{ fontSize: '21px' }}
    />
  ) : (
    <Button
      id="button-assign-device-to-partner"
      {...buttonProps}
      size="small"
      loading={isLoading}
      onClick={handleClick}
    />
  );
};
